import { removeAllStorage } from '@GUTIL/other'
import { convertBaseUrlFromEnv, convertSocketUrlFromEnv } from '@GUTIL/domain'
import { app } from '@/main.js'

const state = {
  showVersion: false,
  version: JSON.parse(unescape(process.env.PACKAGE_JSON || '%7Bversion%3A0%7D'))
    .version,
  folderName: process.env.FOLDER_NAME,
  api_url: process.env.VUE_APP_API,
  socket_url: process.env.VUE_APP_SOCKET_API
}

const actions = {
  [_GM.REMOVE_DATA]() {
    removeAllStorage()
  }
}

const mutations = {
  [_GM.SET_SHOW_VERSION](state, payload) {
    state.showVersion = payload
  },
  [_GM.SET_CONFIG_URL](state) {
    /**
     * 判斷是否轉換url(變數含有^_^)
     * 轉換 -> url環境變數轉換為對應的子域名url
     * ex: api^_^https -> https://api.domain
     * 不轉換 -> url直接取環境變數的值
     */
    const goTransApiUrl = /\^_\^/g.test(process.env.VUE_APP_API)
    let apiUrl = goTransApiUrl
      ? convertBaseUrlFromEnv(process.env.VUE_APP_API)
      : process.env.VUE_APP_API
    state.api_url = apiUrl
  },
  [_GM.SET_CONFIG_SOCKET_URL](state) {
    /**
     * 判斷是否轉換url(變數含有^_^)
     * 轉換 -> url環境變數轉換為對應的子域名url
     * ex: api^_^https -> https://api.domain
     * 不轉換 -> url直接取環境變數的值
     */
    let socket_url = convertSocketUrlFromEnv(process.env.VUE_APP_SOCKET_API)
    state.socket_url = socket_url
  }
}

const getters = {
  showVersion: state => state.showVersion,
  version: state => state.version,
  folderName: state => state.folderName,
  errorCodeArray: state => state.errorCodeArray,
  api_url: state => state.api_url,
  socket_url: state => state.socket_url
}

export default {
  state,
  actions,
  mutations,
  getters
}
